import { useTranslation } from 'react-i18next';

import type { OpeningScheduleResponse } from 'generated/index';
import { dateFormatter } from 'utils/grid';

import type { GridColDef } from '@mui/x-data-grid-pro';

export const useOpeningScheduleColumns =
  (): GridColDef<OpeningScheduleResponse>[] => {
    const { t } = useTranslation('common', {
      keyPrefix: 'planUnitHome.openingHours'
    });

    return [
      {
        field: 'name',
        headerName: t('name'),
        flex: 2,
        minWidth: 160
      },
      {
        field: 'validFrom',
        headerName: t('validFrom'),
        valueFormatter: dateFormatter,
        flex: 1,
        minWidth: 120
      },
      {
        field: 'validTo',
        headerName: t('validTo'),
        valueFormatter: (value?: string) =>
          value ? dateFormatter(value) : t('openEnd'),
        flex: 1,
        minWidth: 120
      },
      {
        field: 'description',
        headerName: t('description'),
        flex: 2,
        minWidth: 160
      }
    ];
  };
